import { jsx as o, jsxs as c, Fragment as A } from "react/jsx-runtime";
import { createContext as R, useContext as U, useState as N, useRef as E, useEffect as $, useCallback as H, useMemo as z } from "react";
import { u as G } from "./useTrackerFloatingMenu-DX8vovPt.js";
import { s as J, a as Q, c as W, t as X, d as Y } from "./trackerReferenceLifecycle-xEM9DpA6.js";
import { F as Z } from "./floating-ui.react-87bo4V3_.js";
const _ = R(null);
function q(a, t, n) {
  const s = {};
  for (const r of Object.keys(n))
    s[r] = r === "status" ? t.status : a.fieldValue(t, r);
  return s;
}
async function ee(a, t, n, s, r) {
  if (!a.updateItem) throw new Error("This item is read-only here");
  const y = q(a, t, n);
  return r?.(n), await a.updateItem(t.id, n), { itemId: t.id, verb: s, updates: n, previous: y };
}
function te(a, t, n, s = {}) {
  const r = {
    ...X(n, {
      actor: a.currentActor?.() ?? null,
      today: Y(),
      input: s.input
    }),
    ...s.extra
  };
  return ee(a, t, r, n.verb, s.onPending);
}
function ae(a, t) {
  const n = a.fieldValue(t, "position"), s = a.fieldValue(t, "positionState"), r = a.fieldValue(t, "owner") ?? t.owner;
  return z(() => Q({
    type: t.type,
    status: t.status ?? null,
    statusOptions: a.statusOptions?.(t.type) ?? [],
    position: typeof n == "string" ? n : null,
    positionState: typeof s == "string" ? s : null,
    positionOwnerName: W(a, r),
    canOpenItem: !!a.openItem
  }), [t.type, t.status, r, n, s, a]);
}
const ne = (a) => a.preventDefault();
function le({
  resolver: a,
  item: t,
  onChanged: n,
  onPending: s,
  request: r,
  onRequestHandled: y,
  readOnly: K,
  className: D
}) {
  const l = a.statusInfo(t), k = ae(a, t), w = U(_), [m, b] = N(null), [v, g] = N(""), [M, O] = N(!1), [B, F] = N(null), I = E(null), x = E(!1), C = E(void 0), i = G({ placement: "bottom-start" }), { isOpen: p, setIsOpen: d } = i;
  $(() => {
    p || (b(null), g(""), F(null), C.current = void 0, x.current && (x.current = !1, w ? w() : I.current?.focus({ preventScroll: !0 })));
  }, [p, w]), $(() => {
    if (!r) return;
    const e = k.find((f) => f.id === r.transitionId);
    y?.(), e && (I.current = document.activeElement, d(!0), b(e), g(r.input), C.current = r.extra);
  }, [y, r, d, k]);
  const S = H(async (e, f) => {
    if (e.opensItem) {
      d(!1), a.openItem?.(t.id);
      return;
    }
    O(!0), F(null);
    try {
      const h = await te(a, t, e, { input: f, extra: C.current, onPending: s });
      d(!1), n?.(h);
    } catch (h) {
      F(h instanceof Error ? h.message : String(h));
    } finally {
      O(!1);
    }
  }, [t, n, s, a, d]);
  if (!l) return null;
  const P = J(t.type, l), L = !K && !!a.updateItem && k.length > 0, V = `tracker-state-word${D ? ` ${D}` : ""}`;
  if (!L)
    return /* @__PURE__ */ o("span", { className: V, "data-tone": P, "data-status": l.value, children: l.label });
  let u = v.trim() || null, T = null;
  if (m?.prompt?.field === "supersededBy" && u) {
    const e = a.resolve(u);
    u = e.state === "resolved" && e.item.id !== t.id ? e.item.id : null, u || (T = e.state === "loading" ? "Looking it up..." : `No other item ${v.trim()}`);
  }
  const j = (e) => {
    e.key === "Enter" && !e.shiftKey && m && u && (e.preventDefault(), S(m, u));
  };
  return /* @__PURE__ */ c(A, { children: [
    /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        ref: i.refs.setReference,
        className: V,
        "data-tone": P,
        "data-status": l.value,
        "data-open": p ? "true" : "false",
        "aria-haspopup": "menu",
        "aria-expanded": p,
        ...i.getReferenceProps(),
        onMouseDown: ne,
        onClick: () => {
          I.current = document.activeElement, d(!p);
        },
        children: [
          l.label,
          /* @__PURE__ */ o("span", { className: "tracker-state-word-chevron", "aria-hidden": "true" })
        ]
      }
    ),
    p ? /* @__PURE__ */ o(Z, { children: /* @__PURE__ */ c(
      "div",
      {
        ref: i.refs.setFloating,
        style: i.floatingStyles,
        className: "tracker-state-menu",
        ...i.getFloatingProps(),
        onMouseDown: (e) => {
          e.target instanceof HTMLTextAreaElement || e.preventDefault();
        },
        children: [
          k.map((e) => /* @__PURE__ */ c("div", { className: "tracker-state-menu-entry", children: [
            e.separatorBefore ? /* @__PURE__ */ o("div", { className: "tracker-state-menu-rule", "aria-hidden": "true" }) : null,
            /* @__PURE__ */ c(
              "button",
              {
                type: "button",
                role: "menuitem",
                className: "tracker-state-menu-row",
                "data-active": m?.id === e.id ? "true" : "false",
                disabled: M,
                onClick: () => {
                  if (e.prompt) {
                    b(e), g("");
                    return;
                  }
                  S(e);
                },
                children: [
                  /* @__PURE__ */ o("span", { className: "tracker-state-menu-label", "data-tone": e.opensItem ? void 0 : e.tone, children: e.label }),
                  e.description ? /* @__PURE__ */ o("span", { className: "tracker-state-menu-description", children: e.description }) : null
                ]
              }
            ),
            m?.id === e.id && e.prompt ? /* @__PURE__ */ c("div", { className: "tracker-state-menu-prompt", children: [
              /* @__PURE__ */ o("label", { className: "tracker-state-menu-description", htmlFor: `tracker-state-prompt-${t.id}`, children: e.prompt.label }),
              /* @__PURE__ */ o(
                "textarea",
                {
                  id: `tracker-state-prompt-${t.id}`,
                  className: "tracker-state-menu-input",
                  rows: e.prompt.field === "supersededBy" ? 1 : 2,
                  autoFocus: !0,
                  value: v,
                  placeholder: e.prompt.placeholder,
                  onFocus: () => {
                    x.current = !0;
                  },
                  onChange: (f) => g(f.target.value),
                  onKeyDown: j
                }
              ),
              T ? /* @__PURE__ */ o("span", { className: "tracker-state-menu-description", children: T }) : null,
              /* @__PURE__ */ c("div", { className: "tracker-state-menu-actions", children: [
                /* @__PURE__ */ o("button", { type: "button", className: "tracker-state-menu-button", onClick: () => b(null), children: "Cancel" }),
                /* @__PURE__ */ o(
                  "button",
                  {
                    type: "button",
                    className: "tracker-state-menu-button",
                    "data-primary": "true",
                    disabled: M || !u,
                    onClick: () => {
                      S(e, u);
                    },
                    children: e.prompt.confirmLabel
                  }
                )
              ] })
            ] }) : null
          ] }, e.id)),
          B ? /* @__PURE__ */ o("div", { className: "tracker-state-menu-error", role: "alert", children: B }) : null,
          /* @__PURE__ */ c("div", { className: "tracker-state-menu-footer", children: [
            "Changes ",
            t.issueKey ?? t.title,
            " for everyone."
          ] })
        ]
      }
    ) }) : null
  ] });
}
export {
  le as TrackerStateMenu,
  _ as TrackerStateMenuFocusContext,
  ee as commitTrackerUpdates,
  q as previousValues,
  te as runStateTransition,
  ae as useStateTransitions
};
//# sourceMappingURL=TrackerStateMenu-Bx0EOzXF.js.map
